import React from "react";
import { jetouricon } from "../../services/utilities/assets";
import "./Maintenance.css";

const Maintenance = () => {
  const handlePortalRedirect = () => {
    window.location.href = "https://dms.jetour.com.pk/";
  };

  return (
    <main className="maintenance-page">
      <div
        className="maintenance-ambient maintenance-ambient-one"
        aria-hidden="true"
      />
      <div
        className="maintenance-ambient maintenance-ambient-two"
        aria-hidden="true"
      />

      <section className="maintenance-shell">
        <div className="maintenance-copy">
          <div className="maintenance-brand-row">
            <img
              src={jetouricon}
              alt="Jetour Dealer"
              className="maintenance-brand-logo"
              loading="eager"
              decoding="async"
            />
            <span className="maintenance-pill">Portal Closed</span>
          </div>

          <h1 className="maintenance-title">
            The portal has been closed.
          </h1>

          <p className="maintenance-description">
            The previous Jetour Dealer Portal has been closed. All dealer
            logins, submissions, and daily workflows now continue at the new
            portal: https://dms.jetour.com.pk/. Please bookmark the new
            address and use it for all future access.
          </p>

          <div className="maintenance-actions">
            <button
              type="button"
              className="maintenance-button"
              onClick={handlePortalRedirect}
            >
              Open New Portal
            </button>
          </div>
        </div>

        {/*
        <div className="maintenance-visual">
          <div className="maintenance-visual-frame">
            <div className="maintenance-visual-topbar">
              <div className="maintenance-visual-status">
                <span className="maintenance-visual-dot" aria-hidden="true" />
                <span>Portal Status</span>
              </div>
              <span className="maintenance-visual-badge">Moved to new URL</span>
            </div>

            <div className="maintenance-progress">
              <div className="maintenance-progress-copy">
                <span>Access</span>
                <strong>Redirect available</strong>
              </div>
              <div className="maintenance-progress-track" aria-hidden="true">
                <span className="maintenance-progress-fill" />
              </div>
            </div>

            <div className="maintenance-image-wrap">
              <img
                src={CarDelivery}
                alt="Jetour vehicle illustration"
                className="maintenance-car"
                loading="eager"
                decoding="async"
              />
            </div>

            <div className="maintenance-status-grid">
              <div className="maintenance-status-card">
                <span className="maintenance-status-label">Mode</span>
                <strong>Closed</strong>
              </div>
              <div className="maintenance-status-card">
                <span className="maintenance-status-label">State</span>
                <strong>Moved</strong>
              </div>
              <div className="maintenance-status-card">
                <span className="maintenance-status-label">Link</span>
                <strong>New portal</strong>
              </div>
            </div>
          </div>
        </div>
        */}
      </section>
    </main>
  );
};

export default Maintenance;
